module.exports = __webpack_public_path__ + "static/media/Layer-20.4a25d1bd.png";